/**
 * Normalize FastAPI/axios error `detail` (string | array | object) for display.
 *
 * @param {*} detail response?.data?.detail
 * @param {string} [fallbackMessage]
 * @returns {string}
 */
const OBJECT_PREVIEW_CHARS = 480;

export default function normalizeAxiosDetail(detail, fallbackMessage) {
  if (!detail) return fallbackMessage || "Request failed";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((item) => {
        if (typeof item === "string") return item;
        if (item && typeof item === "object") {
          const loc = Array.isArray(item.loc) ? item.loc.join(".") : item.loc;
          return `${loc || "field"}: ${item.msg || JSON.stringify(item)}`;
        }
        return String(item);
      })
      .join(" | ");
  }
  if (typeof detail === "object" && detail !== null) {
    if (typeof detail.message === "string") return detail.message;
    if (typeof detail.msg === "string") return detail.msg;
    try {
      const s = JSON.stringify(detail);
      if (s.length <= OBJECT_PREVIEW_CHARS) return s;
      return `${s.slice(0, OBJECT_PREVIEW_CHARS)}…`;
    } catch {
      return fallbackMessage || "Request failed";
    }
  }
  return String(detail);
}
